import React, { useState } from 'react';
import { XIcon, AlertCircleIcon } from 'lucide-react';
interface AddVehicleModalProps {
  onClose: () => void;
  onAdd: (vehicle: Omit<Vehicle, 'id' | 'addedAt' | 'status' | 'ticketNumber' | 'addedBy' | 'addedByName'>) => void;
  maxPumps: number;
  existingPlateNumbers: string[];
}
export function AddVehicleModal({
  onClose,
  onAdd,
  maxPumps,
  existingPlateNumbers
}: AddVehicleModalProps) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [plateNumber, setPlateNumber] = useState('');
  const [vehicleType, setVehicleType] = useState('Voiture');
  const [category, setCategory] = useState('Particulier');
  const [pumpNumber, setPumpNumber] = useState(1);
  const [serviceType, setServiceType] = useState('Essence');
  const [estimatedPrice, setEstimatedPrice] = useState('');
  const [error, setError] = useState('');
  const checkDuplicatePlateNumber = (plate: string) => {
    const normalizedPlate = plate.trim().toLowerCase();
    return existingPlateNumbers.some(existing => existing.toLowerCase() === normalizedPlate);
  };
  const handlePlateNumberChange = (value: string) => {
    setPlateNumber(value);
    if (error) setError('');
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedPlateNumber = plateNumber.trim();
    if (!trimmedPlateNumber) {
      setError("Le numéro d'immatriculation est requis");
      return;
    }
    if (checkDuplicatePlateNumber(trimmedPlateNumber)) {
      setError("Ce numéro d'immatriculation existe déjà dans la file d'attente");
      return;
    }
    onAdd({
      name: name.trim() || 'Client',
      phone: phone.trim() || 'Non renseigné',
      plateNumber: trimmedPlateNumber,
      vehicleType,
      category,
      pumpNumber,
      serviceType,
      estimatedPrice: estimatedPrice ? Number(estimatedPrice) : 0
    });
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-11">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 max-h-[90vh] overflow-y-auto" data-id="element-12">
        <div className="flex items-center justify-between mb-6" data-id="element-13">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-14">
            Ajouter un Véhicule
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-15">
            <XIcon className="w-6 h-6" data-id="element-16" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-17">
          <div data-id="element-18">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-19">
              Numéro d'Immatriculation <span className="text-red-600" data-id="element-20">*</span>
            </label>
            <input type="text" value={plateNumber} onChange={e => handlePlateNumberChange(e.target.value)} className={`w-full px-4 py-3 border-2 rounded-xl focus:outline-none transition-colors ${error ? 'border-red-500 focus:border-red-600' : 'border-gray-200 focus:border-blue-500'}`} placeholder="Ex: ABC-123" required data-id="element-21" />
            {error && <div className="mt-2 flex items-center gap-2 text-red-600 text-sm bg-red-50 px-3 py-2 rounded-lg border border-red-200" data-id="element-22">
                <AlertCircleIcon className="w-4 h-4 flex-shrink-0" data-id="element-23" />
                <span data-id="element-24">{error}</span>
              </div>}
          </div>
          <div data-id="element-25">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-26">
              Nom du Client{' '}
              <span className="text-gray-400 text-xs" data-id="element-27">(optionnel)</span>
            </label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors" placeholder="Ex: Amadou Diallo" data-id="element-28" />
          </div>
          <div data-id="element-29">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-30">
              Téléphone{' '}
              <span className="text-gray-400 text-xs" data-id="element-31">(optionnel)</span>
            </label>
            <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors" placeholder="Ex: +223 70 12 34 56" data-id="element-32" />
          </div>
          <div data-id="element-33">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-34">
              Catégorie
            </label>
            <select value={category} onChange={e => setCategory(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors" data-id="element-35">
              <option data-id="element-36">Particulier</option>
              <option data-id="element-37">Professionnel</option>
              <option data-id="element-38">Transport</option>
              <option data-id="element-39">Entreprise</option>
              <option data-id="element-40">VIP</option>
            </select>
          </div>
          <div data-id="element-41">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-42">
              Type de Véhicule
            </label>
            <select value={vehicleType} onChange={e => setVehicleType(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors" data-id="element-43">
              <option data-id="element-44">Voiture</option>
              <option data-id="element-45">Moto</option>
              <option data-id="element-46">Camion</option>
              <option data-id="element-47">SUV</option>
            </select>
          </div>
          <div data-id="element-48">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-49">
              Numéro de Pompe
            </label>
            <select value={pumpNumber} onChange={e => setPumpNumber(Number(e.target.value))} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors" data-id="element-50">
              {Array.from({
              length: maxPumps
            }, (_, i) => i + 1).map(num => <option key={num} value={num} data-id="element-51">
                  Pompe {num}
                </option>)}
            </select>
          </div>
          <div data-id="element-52">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-53">
              Type de Service
            </label>
            <select value={serviceType} onChange={e => setServiceType(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors" data-id="element-54">
              <option data-id="element-55">Essence</option>
              <option data-id="element-56">Diesel</option>
              <option data-id="element-57">GPL</option>
              <option data-id="element-58">Électrique</option>
            </select>
          </div>
          <div data-id="element-59">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-60">
              Prix (estimatif) - FCFA{' '}
              <span className="text-gray-400 text-xs" data-id="element-61">(optionnel)</span>
            </label>
            <input type="number" value={estimatedPrice} onChange={e => setEstimatedPrice(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors" placeholder="Ex: 15000" min="0" step="500" data-id="element-62" />
          </div>
          <div className="flex gap-3 pt-4" data-id="element-63">
            <button type="button" onClick={onClose} className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-colors" data-id="element-64">
              Annuler
            </button>
            <button type="submit" className="flex-1 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold transition-colors shadow-lg" data-id="element-65">
              Ajouter
            </button>
          </div>
        </form>
      </div>
    </div>;
}